/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';
import { useToast } from '../../../../context/ToastContext';

/*Import Requisição API*/
import api from '../../../../api';
import { converterDataParaYMD, validadorDataNascimento, formatadorCPF, formatadorCNPJ } from '../../../../utils/Validadores';

export default function EditarFuncionario() {
    /* Variáveis auxiliares */
    const navigate = useNavigate();
    const location = useLocation();
    const { showToast } = useToast();
    const id_funcionario = location.state?.id;
    const [DataNascimentoValido, setDataNascimentoValido] = useState();

    /* ID's */
    const [usuario_id, setIdUsuario] = useState();

    /* Estado do loading */
    const [loading, setLoading] = useState(false);

    /* Dados do Funcionário */
    const [nome, setNome] = useState("");
    const [cpfCnpj, setCpfCnpj] = useState("");
    const [email, setEmail] = useState("");
    const [celular, setCelular] = useState("");
    const [dataNascimento, setDataNascimento] = useState("");
    const [sexo, setSexo] = useState("");
    const [nivelAcesso, setNivelAcesso] = useState("");
    const [termosAceitos, setTermosAceitos] = useState("");
    const [aceitoEnvioEmail, setAceitoEnvioEmail] = useState("");

    /* Endereço */
    const [cep, setCep] = useState("");
    const [logradouro, setLogradouro] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
    }, []);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    /* Buscar usuário logado */
    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                } else {
                    showToast('Erro ao carregar dados do usuário.', 'error');
                }
            } catch (error) {
                showToast('Erro ao buscar dados do usuário.', 'error');
            }
        };
        buscarDadosUsuario();
    }, []);

    /* Carregar dados do funcionário */
    useEffect(() => {
        const carregarDados = async () => {
            setLoading(true);
            try {
                const response = await api.get(`/funcionarios/${id_funcionario}`);
                if (response.data.success) {
                    const funcionario = response.data.funcionario;
                    setNome(funcionario.nome || '');
                    setCpfCnpj(funcionario.cpf_cnpj || '');
                    setEmail(funcionario.email || '');
                    setCelular(funcionario.celular || '');
                    setDataNascimento(
                        funcionario.data_nascimento
                            ? new Date(funcionario.data_nascimento).toLocaleDateString('pt-BR')
                            : ''
                    );
                    setSexo(funcionario.sexo || '');
                    setNivelAcesso(funcionario.nivel_acesso || '');
                    setTermosAceitos(funcionario.termosAceitos || false);
                    setAceitoEnvioEmail(funcionario.aceitoEnvioEmail || false);
                    setDataNascimentoValido(validadorDataNascimento(funcionario.dataNascimento));

                    if (funcionario.endereco) {
                        setCep(funcionario.endereco.cep || '');
                        setLogradouro(funcionario.endereco.logradouro || '');
                        setNumero(funcionario.endereco.numero || '');
                        setComplemento(funcionario.endereco.complemento || '');
                        setBairro(funcionario.endereco.bairro || '');
                        setCidade(funcionario.endereco.cidade || '');
                        setEstado(funcionario.endereco.estado || '');
                    }
                } else {
                    showToast('Erro ao carregar os dados do funcionário.', 'error');
                    navigate(-1);
                }
            } catch (error) {
                showToast('Erro ao conectar com o servidor.', 'error');
                navigate(-1);
            } finally {
                setLoading(false);
            }
        };

        if (id_funcionario) carregarDados();
    }, [id_funcionario]);

    /* Editar funcionário */
    const salvarEdicaoFuncionario = async (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);

        if (!nivelAcesso) {
            showToast('O campo de nível de acesso é obrigatório.', 'error');
            setLoading(false);
            return;
        }

        const dataNascimentoFormatada = converterDataParaYMD(dataNascimento);

        const funcionario = {
            nome,
            cpf_cnpj: cpfCnpj,
            email,
            celular,
            data_nascimento: dataNascimentoFormatada,
            sexo,
            nivel_acesso: nivelAcesso,
            termos_aceitos: termosAceitos,
            aceito_envio_email: aceitoEnvioEmail,
            endereco: {
                cep,
                logradouro,
                numero,
                complemento,
                bairro,
                cidade,
                estado
            },
            idAdministrador: usuario_id
        };

        try {
            const response = await api.put(`/funcionarios/${id_funcionario}`, funcionario);
            if (response.data.success) {
                showToast('Funcionário atualizado com sucesso!', 'success');
                navigate('/menu/funcionarios');
            } else {
                showToast(response.data.message || 'Erro ao atualizar funcionário.', 'error');
            }
        } catch (error) {
            console.error('Erro ao salvar edição:', error);
            showToast('Erro ao conectar com o servidor. Tente novamente.', 'error');
        } finally {
            setLoading(false);
        }
    };

    /* CEP */
    const buscarEnderecoPorCep = async (cep) => {
        if (cep.length !== 8) {
            showToast('Por favor, insira um CEP válido com 8 dígitos.', 'error');
            return;
        }
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const data = await response.json();
            if (data.erro) {
                showToast('CEP não encontrado.', 'error');
            } else {
                setLogradouro(data.logradouro || '');
                setBairro(data.bairro || '');
                setCidade(data.localidade || '');
                setEstado(data.uf || '');
            }
        } catch (error) {
            showToast('Erro ao buscar o endereço. Tente novamente mais tarde.', 'error');
        }
    };

    const mascaraCep = (valor) => {
        return valor.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2').slice(0, 9);
    };

    const handleDataNascimentoChange = (e) => {
        let valor = e.target.value.replace(/\D/g, '');
        if (valor.length > 2 && valor.length <= 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2)}`;
        } else if (valor.length > 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2, 4)}/${valor.slice(4, 8)}`;
        }
        setDataNascimento(valor);
        if (valor.length === 10) {
            setDataNascimentoValido(validadorDataNascimento(valor));
        }
    };

    const handleCpfOuCnpjChange = (e) => {
        const sanitized = e.target.value.replace(/\D/g, '');
        let formatado = sanitized.length <= 11
            ? formatadorCPF(sanitized)
            : formatadorCNPJ(sanitized);
        setCpfCnpj(formatado);
    };

    return (
        <section className='container-principal-editar-funcionario'>

            <dialog id="CaixaDeDialogo" className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button id="botao" onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <Cabecalho />

            <CookieAceite />

            <main>

                <MenuLateral />

                <section className='conteudo-editar-funcionario'>

                    <div className='titulo-perfil'>
                        <h1><span>Funcionarios</span> &gt; Editar funcionario</h1>
                    </div>

                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando dados do funcionário</h2>
                        </div>
                    ) : (
                        <div className='perfil-editar-funcionario'>
                            <h2>Digite os dados do funcionario</h2>
                            <form className='form-editar-funcionario' onSubmit={salvarEdicaoFuncionario}>

                                <label className='lasbel-nome'>Nome: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-nome">
                                    <input
                                        type="text"
                                        value={nome}
                                        onChange={(e) => setNome(e.target.value)}
                                        maxLength={255}
                                        placeholder="Digite o nome do funcionario"
                                    />
                                </div>

                                <label>CPF/CNPJ: <span className='span-obrigatorio'>*</span></label>
                                <div className='input-CpfOuCnpj'>
                                    <input
                                        type="text"
                                        value={cpfCnpj}
                                        onChange={handleCpfOuCnpjChange}
                                        placeholder="Digite CPF ou CNPJ"
                                    />
                                </div>

                                <label>E-mail: <span className='span-obrigatorio'>*</span></label>
                                <div className='input-email'>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Digite o e-mail"
                                    />
                                </div>

                                <label>Celular: <span className='span-obrigatorio'>*</span></label>
                                <div className='input-celular'>
                                    <input
                                        type="text"
                                        value={celular}
                                        onChange={(e) => setCelular(e.target.value)}
                                        placeholder="Digite o celular"
                                    />
                                </div>

                                <label>Data de Nascimento:</label>
                                <div className='input-dataNascimento'>
                                    <input
                                        type="text"
                                        value={dataNascimento}
                                        onChange={handleDataNascimentoChange}
                                        placeholder="Digite sua data de nascimento"
                                        maxLength="10"
                                    />
                                </div>

                                <label>Sexo:</label>
                                <div className='input-sexo'>
                                    <select value={sexo} onChange={(e) => setSexo(e.target.value)}>
                                        <option value="">Selecione</option>
                                        <option value="Masculino">Masculino</option>
                                        <option value="Feminino">Feminino</option>
                                        <option value="Outro">Outro</option>
                                    </select>
                                </div>

                                <label>Nível de Acesso:</label>
                                <div className='input-nivelAcesso'>
                                    <select value={nivelAcesso} onChange={(e) => setNivelAcesso(e.target.value)}>
                                        <option value="" disabled>Selecione o nível de acesso</option>
                                        <option value="Administrador">Administrador</option>
                                        <option value="Entregador">Entregador</option>
                                        <option value="Separador">Separador</option>
                                        <option value="AssistenteAtendimento">Assistente de Atendimento</option>
                                        <option value="Financeiro">Financeiro</option>
                                    </select>
                                </div>

                                <div className='linha-1-endereco'>
                                    <div className='conteudo-cep'>
                                        <label className='lasbel-cep'>CEP: <span className='span-obrigatorio'>*</span></label>
                                        <div className='input-cep'>
                                            <input
                                                type="text"
                                                value={cep}
                                                onChange={(e) => setCep(mascaraCep(e.target.value))}
                                                onBlur={() => buscarEnderecoPorCep(cep.replace(/\D/g, ''))}
                                                maxLength={8}
                                                placeholder="Digite o CEP"
                                            />
                                        </div>
                                    </div>

                                    <div className='conteudo-numero'>
                                        <label className='lasbel-numero'>Número: <span className='span-obrigatorio'>*</span></label>
                                        <div className='input-numero'>
                                            <input
                                                type="text"
                                                value={numero}
                                                onChange={(e) => setNumero(e.target.value)}
                                                placeholder="Digite o Nº"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <label>Logradouro:</label>
                                <div className='input-logradouro'>
                                    <input
                                        type="text"
                                        value={logradouro}
                                        onChange={(e) => setLogradouro(e.target.value)}
                                        placeholder="Logradouro"
                                        disabled
                                    />
                                </div>

                                <label>Bairro:</label>
                                <div className='input-bairro'>
                                    <input
                                        type="text"
                                        value={bairro}
                                        onChange={(e) => setBairro(e.target.value)}
                                        placeholder="Bairro"
                                        disabled
                                    />
                                </div>

                                <div className='linha-5-endereco'>
                                    <div className='conteudo-cidade'>
                                        <label className='lasbel-cidade'>Cidade:</label>
                                        <div className='input-cidade'>
                                            <input
                                                type="text"
                                                value={cidade}
                                                onChange={(e) => setCidade(e.target.value)}
                                                placeholder="Cidade"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className='conteudo-estado'>
                                        <label className='label-estado'>Estado:</label>
                                        <div className='input-estado'>
                                            <input
                                                type="text"
                                                value={estado}
                                                onChange={(e) => setEstado(e.target.value)}
                                                maxLength={2}
                                                placeholder="Estado"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <label>Complemento:</label>
                                <div className='input-complemento'>
                                    <input
                                        type="text"
                                        value={complemento}
                                        onChange={(e) => setComplemento(e.target.value)}
                                        maxLength={255}
                                        placeholder="Digite o complemento (Opcional)"
                                    />
                                </div>

                                <button className='bnt-editar-funcionario' type="submit">Editar Funcionario</button>
                            </form>
                        </div>
                    )}
                </section>
            </main >

            <Rodape />

        </section >
    );
}